import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'pm-usermanagement',
  templateUrl: './usermanagement.component.html',
  styleUrls: ['./usermanagement.component.css']
})
export class UsermanagementComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
